import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import ViewModal from "components/modal/ViewVehiceleCategoryModal";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import SoldOutDrawer from "components/drawer/SoldOutDrawer";

const SoldOutTable = ({
  vehicleCategory,
  perpage,
  currentPage,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate, isViewMode } =
    useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={vehicleCategory} />
      <MainDrawer>
        <SoldOutDrawer id={serviceId} isViewMode={isViewMode} />
      </MainDrawer>

      <TableBody>
        {vehicleCategory?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="font-semibold uppercase text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data["city_name"]}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data["package_type"]}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data.vehicle_type
                .map((type) => data.vehicle_type_names[type])
                .filter(Boolean)
                .join(", ")}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data["start_date"]}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data["end_date"]}
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  title={data["Vehicle Category"]}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default SoldOutTable;
